module.exports = __webpack_public_path__ + "static/antd-button-icon-7878bd8ff599bb3d359bbf8706ba4d42.png";